export default defineNuxtPlugin(() => {
  // для инициализации виджета внутри ВКонтакте необходимо отправить событие VKWebAppInit
  const initVkBridge = () => {
    const scriptVK = document.createElement('script')

    scriptVK.async = true
    scriptVK.type = 'text/javascript'
    scriptVK.src = 'https://unpkg.com/@vkontakte/vk-bridge/dist/browser.min.js'

    document.head.appendChild(scriptVK)

    scriptVK.onload = function () {
      // vkBridge переменная устанавливается из скрипта который загружается из vkontakte
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (window.vkBridge) {
        const scriptInit = document.createElement('script')

        scriptInit.innerHTML = `
        window.vkBridgePromise = vkBridge.send('VKWebAppInit').then((data) => {
          if (data.result) {
            console.log('bridge.send VKWebAppInit success', data.result)
          } else {
            console.error('bridge.send VKWebAppInit failed, не пришла data.result')
          }
        })
        .catch((error) => {
          console.log('bridge.send VKWebAppInit failed', error)
        });
      `
        document.head.appendChild(scriptInit)
      }
    }
  }

  initVkBridge()
})
